export default {
  props: ['data'],
  mounted () {
    this.renderFromData()
  },
  watch: {
    data: {
      handler () {
        this.renderFromData()
      },
      deep: true
    }
  },
  methods: {
    renderFromData () {
      if (!this.data || !this.data.report) {
        return
      }

      if (this.$data._chart) {
        this.$data._chart.destroy()
      }

      this.renderChart(this.data.report, this.data.options)

      this.$nextTick(() => {
        if (this.$data._chart) {
          this.$data._chart.resize()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/charts/chartRendererMixin.js